//回访筛单池
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane label="常规" name="first">
      <editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :dealType="orderDealType" :parent-target="_self"
                @reload="$reloadHandle" @editViewDataUpdate="editViewDataUpdate"></editView>
      </el-tab-pane>
      <el-tab-pane label="列表" name="second">
        <div>
          <vxe-grid show-overflow :stripe="true" border="default" :row-config="{ isHover: true }" ref="table-m1"
            v-bind="vxeOption" @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle"
            :checkbox-config="{ labelField: '', highlight: true, reserve: true, range: true }">

            <template #form>
              <div class="clearfix screen-btns" style="padding: 0px 6px 6px 0;">
                <div class="fl">
                  <vxe-button v-if="soRecallHistoryExport" status="primary" class="button-sty" icon="el-icon-top" @click="doExcle">导出
                  </vxe-button>
                  <vxe-button v-if="submitRobot" status="primary" class="button-sty" icon="el-icon-user" @click="submitRobotAction">提交机器人
                  </vxe-button>
                  <vxe-button v-if="soRecallHistoryImport" status="primary" class="button-sty" icon="el-icon-bottom" @click="$refs.excelUpload.show()">导入回访结果
                  </vxe-button>
                  <vxe-button v-if="soRecallHistoryImport" status="primary" class="button-sty" icon="el-icon-bottom" @click="$refs.callExcelUpload.show()">导入外呼结果
                  </vxe-button>
                  <vxe-button v-if="submitRobot" status="primary" class="button-sty" icon="el-icon-user" @click="submitHCRobotAction">挂起取消提交机器人
                  </vxe-button>
                </div>
                <div class="fr" style="display: flex;">

                  <el-input  type="textarea"
                             :autosize="{ minRows: 1, maxRows: 8}" placeholder="请输入工单编号或用户联系方式" style="width: 200px; height: 27px !important;"
                             v-model="formData.searchValue" @keyup.enter.native="searchEvent" clearable>
                    <!-- <i slot="prefix" class="el-input__icon el-icon-search"></i> -->
                  </el-input>

                  <vxe-button status="warning" icon="el-icon-search" style="margin: 0 0 0 10px;" class="button-sty"
                    @click="searchEvent">搜索
                  </vxe-button>

                  <vxe-button status="warning" icon="el-icon-brush" style="margin: 0 0 0 10px;" class="button-sty"
                    @click="clearEvent">一键清空
                  </vxe-button>

                  <div style="display: flex;margin-top: 5px;margin-right: 5px;color: #409eff;" @click="show3 = !show3">
                    <svg t="1682558973727" class="icon" viewBox="0 0 1024 1024" version="1.1"
                      xmlns="http://www.w3.org/2000/svg" p-id="1587" width="16" height="16">
                      <path
                        d="M921.6 686.08h-245.76c-10.24 0-20.48-10.24-20.48-20.48s10.24-20.48 20.48-20.48H921.6c10.24 0 20.48 10.24 20.48 20.48s-10.24 20.48-20.48 20.48z m0-122.88h-245.76c-10.24 0-20.48-10.24-20.48-20.48s10.24-20.48 20.48-20.48H921.6c10.24 0 20.48 10.24 20.48 20.48s-10.24 20.48-20.48 20.48z m-166.4-289.28c-2.56 2.56-243.2 227.84-243.2 227.84v389.12l-163.84-81.92v-307.2L112.64 281.6c-2.56-2.56-5.12-5.12-7.68-5.12-15.36-15.36-23.04-35.84-23.04-58.88 0-46.08 38.4-84.48 84.48-84.48h527.36c46.08 0 84.48 38.4 84.48 84.48 0 23.04-10.24 43.52-23.04 56.32zM693.76 179.2H166.4C145.92 179.2 128 197.12 128 217.6c0 10.24 2.56 20.48 10.24 25.6l2.56 2.56 227.84 215.04 15.36 12.8 2.56 25.6-2.56 273.92 81.92 40.96V473.6l15.36-12.8 230.4-212.48 2.56-2.56c7.68-7.68 10.24-15.36 10.24-25.6 7.68-23.04-10.24-40.96-30.72-40.96z m-17.92 588.8H921.6c10.24 0 20.48 10.24 20.48 20.48s-10.24 20.48-20.48 20.48h-245.76c-10.24 0-20.48-10.24-20.48-20.48 0-12.8 7.68-20.48 20.48-20.48z"
                        fill="#0ea2f0" p-id="1588"></path>
                    </svg>
                    <span>更多筛选</span>
                  </div>
                </div>
              </div>
              <el-collapse-transition name="fade">

                <vxe-form ref="form" v-if="show3" class="screen-box" title-width="5vw" title-align="right"
                  :data="formData" @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent">
                  <vxe-form-item title="服务类型:">
                    <template v-slot >
                      <el-cascader v-model="formData.serviceTypeNames" :key="formData.value" :options="serviceTypeOption"  style="width:9vw;"
                                   :props="props"
                                   clearable
                      ></el-cascader>
                    </template>
                  </vxe-form-item>

<!--                  <vxe-form-item title="服务类型:" field="name">
                    <template v-slot>
                      <service-type-cascader style="width:9vw;" :param="{multiple: true,checkStrictly: true,}"
                                             @selectedServiceType="commitServiceTypes" />
                    </template>
                  </vxe-form-item>-->

                  <vxe-form-item title="购买渠道:" field="name">
                    <template v-slot>
                      <el-select v-model="formData.buyChannelId" placeholder="购买渠道" style="width:9vw ;" clearable>
                        <el-option v-for="item in buyChannelOption" :key="item.buyChannelName"
                          :label="item.buyChannelName" :value="item.id" />
                      </el-select>
                    </template>
                  </vxe-form-item>

                  <!-- <vxe-form-item title="网点名称:" field="name">
    <template v-slot>
      <el-input v-model="formData.orgId" size="small" style="width:9vw ;" clearable>
        <i slot="suffix" class="el-input__icon el-icon-search" @click="showPreconditionDialog = true"></i>
      </el-input>
    </template>
  </vxe-form-item> -->

                  <vxe-form-item title="保修类型:" field="name">
                    <template v-slot>
                      <el-select v-model="formData.guaranteeType" style="width:9vw ;" clearable>
                        <el-option :value="null" label="全部"></el-option>
                        <el-option :value="1" label="保内"></el-option>
                        <el-option :value="2" label="保外"></el-option>
                        <el-option :value="3" label="未知"></el-option>
                        <el-option :value="4" label="保外转保内"></el-option>
                      </el-select>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="服务商:" field="name">
                    <template v-slot>
                      <el-autocomplete style="width:9vw ;"
                                       class="inline-input"
                                       v-model="formData.siteName"
                                       :fetch-suggestions="querySiteSearch"
                                       placeholder="请输入内容"
                                       :trigger-on-focus="false"
                                       @select="handleSiteSelect"
                      ></el-autocomplete>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="完工时间:" field="name" style="width:25%!important;">
                    <template v-slot style=" display: inline-block;width:25%!important;">
                      <el-date-picker style="width: 18vw;" v-model="formData.completeDate" type="daterange" align="right"
                                      unlink-panels range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                                      :picker-options="pickerOptions" value-format="yyyy-MM-dd">
                      </el-date-picker>
                    </template>
                  </vxe-form-item>

<!--                  <vxe-form-item title="工单号(批量):" field="name">
                    <template v-slot>
                      <el-input  type="textarea" :autosize="{ minRows: 1, maxRows: 3, maxHeight: '100px' }"  v-model="formData.orderNoArr"  style="width:9vw ;" clearable/>
                    </template>
                  </vxe-form-item>-->

                  <vxe-form-item title="删除工单:" field="name">
                    <template v-slot>
                      <el-input  type="textarea" :autosize="{ minRows: 1, maxRows: 3, maxHeight: '100px' }" v-model="formData.deleteOrder"  style="width:9vw ;" clearable/>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="配件数量:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.partsBegin" class="priceInput" style="width:4vw;" clearable/><span
                        style="display: inline-block;width:1vw;text-align: center;">-</span>
                        <el-input
                        v-model="formData.partsEnd" class="priceInput" ref="prodEnd" style="width: 4vw;" clearable/>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="回访次数:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.recallBegin" class="priceInput" style="width: 4vw" clearable/><span
                        style="display: inline-block;width:1vw;text-align: center;">-</span>
                        <el-input
                        v-model="formData.recallEnd" class="priceInput" ref="prodEnd" style="width:4vw;" clearable/>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="查询数量:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.queryNum" size="small" style="width:9vw ;" clearable/>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="创建时间:" field="name" style="width:25%!important;">
                    <template v-slot style=" display: inline-block;width:25%!important;">
                      <el-date-picker style="width: 18vw;" v-model="formData.createDate" type="daterange" align="right"
                                      unlink-panels
                                      range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                                      :picker-options="pickerOptions" value-format="yyyy-MM-dd">
                      </el-date-picker>
                    </template>
                  </vxe-form-item>

<!--                  <vxe-form-item title="产品大类:" field="name">
                    <template v-slot>
                      <el-select v-model="formData.bigCategoryId" placeholder="产品大类" style="width:9vw;" clearable>
                        <el-option v-for="item in bigCategoryOption" :key="item.categoryName"
                          :label="item.categoryName" :value="item.id" />
                      </el-select>
                    </template>
                  </vxe-form-item>-->

                  <vxe-form-item title="配件情况:" field="name">
                    <template v-slot>
                      <el-select v-model="formData.partsRecall" style="width:9vw ;" clearable>
                        <el-option :value="null" label="全部"></el-option>
                        <el-option :value="1" label="属实"></el-option>
                        <el-option :value="2" label="不属实"></el-option>
                        <el-option :value="3" label="无果"></el-option>
                        <el-option :value="0" label="空"></el-option>
                      </el-select>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="回访情况:" field="name">
                    <template v-slot>
                      <el-select v-model="formData.huiFangQingKuang" style="width:9vw ;" clearable>
                        <el-option :value="null" label="全部"></el-option>
                        <el-option :value="1" label="属实"></el-option>
                        <el-option :value="2" label="不属实"></el-option>
                        <el-option :value="3" label="无果"></el-option>
                      </el-select>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="满意度:" field="name">
                    <template v-slot>
                      <el-select v-model="formData.manYi" style="width:9vw ;" clearable>
                        <el-option :value="null" label="全部"></el-option>
                        <el-option :value="1" label="非常满意"></el-option>
                        <el-option :value="2" label="满意"></el-option>
                        <el-option :value="3" label="一般"></el-option>
                        <el-option :value="4" label="不满意"></el-option>
                        <el-option :value="5" label="非常不满意"></el-option>
                        <el-option :value="6" label="未评价"></el-option>
                      </el-select>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="产品大类:" field="name">
                    <template v-slot>
                      <el-select v-model="formData.bigCategoryId" placeholder="产品大类" style="width:9vw;" clearable>
                        <el-option v-for="item in bigCategoryOption" :key="item.categoryName"
                          :label="item.categoryName" :value="item.id" />
                      </el-select>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="回访时间:" field="name" style="width:25%!important;">
                    <template v-slot style=" display: inline-block;width:25%!important;">
                      <el-date-picker style="width: 18vw;" v-model="formData.recallDate" type="daterange" align="right"
                        unlink-panels range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                        :picker-options="pickerOptions" value-format="yyyy-MM-dd">
                      </el-date-picker>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="查询重单数:" field="isOutPhone" >
                    <template v-slot>
                      <el-checkbox-group v-model="formData.isOutPhone" style="width: 24vw;" @change="selectIsOutPhone">
                        <el-checkbox :label="2" :disabled="canCheck">2个重单</el-checkbox>
                        <el-checkbox :label="3" :disabled="canCheck">3个重单</el-checkbox>
                        <el-checkbox :label="4" :disabled="canCheck">超3个重单</el-checkbox>
                      </el-checkbox-group>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title=" " field="name" style="visibility: hidden">
                    <template v-slot>
                      <el-select  v-model="formData.bigCategoryId" placeholder="产品大类" style="width:9vw ;visibility: hidden" clearable>
                        <el-option v-for="item in bigCategoryOption" :key="item.categoryName"
                          :label="item.categoryName" :value="item.id" />
                      </el-select>
                    </template>
                  </vxe-form-item>
                     <vxe-form-item title=" " field="name" style="visibility: hidden">
                    <template v-slot>
                      <el-select v-model="formData.bigCategoryId" placeholder="产品大类" style="width:9vw ;visibility: hidden" clearable>
                        <el-option v-for="item in bigCategoryOption" :key="item.categoryName"
                          :label="item.categoryName" :value="item.id" />
                      </el-select>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="导入时间:" field="name" style="width:25%!important;">
                    <template v-slot style=" display: inline-block;width:25%!important;">
                      <el-date-picker style="width: 18vw;" v-model="formData.importRobotTime" type="daterange" align="right"
                                      unlink-panels range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                                      :picker-options="pickerOptions" value-format="yyyy-MM-dd">
                      </el-date-picker>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="回访状态:" field="name">
                    <template v-slot>
                      <el-select v-model="formData.recallStat" style="width:9vw ;" clearable>
                        <el-option :value="null" label="全部"></el-option>
                        <el-option :value="0" label="未回访"></el-option>
                        <el-option :value="1" label="已抽样"></el-option>
                        <el-option :value="2" label="已回访"></el-option>
                        <el-option :value="5" label="用户已评价"></el-option>
                      </el-select>
                    </template>
                  </vxe-form-item>


                  <vxe-form-item title="权益名称:" field="name">
                    <template v-slot>
                      <el-input  type="textarea" :autosize="{ minRows: 1, maxRows: 3, maxHeight: '100px' }" v-model="formData.rightName"  style="width:9vw ;" clearable/>
                    </template>
                  </vxe-form-item>

                  <!-- <vxe-form-item title="" field="isOutPhone">
                    <template v-slot>
                  <vxe-button status="warning" icon="el-icon-brush" style="margin: 0 0 0 100px;" class="button-sty"
                    @click="searchEvent">一键清空
                  </vxe-button>
                </template>
                  </vxe-form-item> -->
                </vxe-form>
              </el-collapse-transition>
              <div class="goodsStatus">
                <div v-for="(item, index) in goodsStatusList" :key="index">
                  <div :class="{
											btnGoodsStatusBt1: goodsStatusIndex == index,
											btnGoodsStatusBt: goodsStatusIndex != index
										}" @click="changeGoodsStatus(item, index)">
                    <span>{{ item.name }}</span> <span v-if="item.name!='所有'" class="num_color">{{ item.num }}</span>
                  </div>
                </div>
              </div>
            </template>
            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>

            <template #showStat="{row}">
              <span class="txt-status " v-if="row.stat == 1">登记</span>
              <span class="txt-status " v-else-if="row.stat == 2">发布</span>
              <span class="txt-status " v-else-if="row.stat == 5">已派网点</span>
              <span class="txt-status " v-else-if="row.stat == 6">网点已接单</span>
              <span class="txt-status " v-else-if="row.stat == 9">已派师傅</span>
              <span class="txt-status " v-else-if="row.stat == 10">师傅已接单</span>
              <span class="txt-status " v-else-if="row.stat == 11">已预约</span>
              <span class="txt-status " v-else-if="row.stat == 13">已出发</span>
              <span class="txt-status " v-else-if="row.stat == 17">已上门</span>
              <span class="txt-status neutral" v-else-if="row.stat == 20">完工暂存</span>
              <span class="txt-status neutral" v-else-if="row.stat == 30">寄修待确认</span>
              <span class="txt-status neutral" v-else-if="row.stat == 31">待寄件</span>
              <span class="txt-status neutral" v-else-if="row.stat == 32">已寄待签收</span>
              <span class="txt-status neutral" v-else-if="row.stat == 36">待维修</span>
              <span class="txt-status neutral" v-else-if="row.stat == 37">修好待寄出</span>
              <span class="txt-status neutral" v-else-if="row.stat == 38">客户待签收</span>
              <span class="txt-status neutral" v-else-if="row.stat == 40">退换待确认</span>
              <span class="txt-status neutral" v-else-if="row.stat == 41">旧机待退回</span>
              <span class="txt-status neutral" v-else-if="row.stat == 42">旧机待签收</span>
              <span class="txt-status " v-else-if="row.stat == 43">旧机已签收</span>
              <span class="txt-status neutral" v-else-if="row.stat == 44">新机待寄出</span>
              <span class="txt-status " v-else-if="row.stat == 45">新机已寄出</span>
              <span class="txt-status neutral" v-else-if="row.stat == 47">新机待签收</span>
              <span class="txt-status " v-else-if="row.stat == 48">新机已签收</span>
              <span class="txt-status disable" v-else-if="row.stat == 49">退换被驳回</span>
              <span class="txt-status " v-else-if="row.stat == 61">已完工</span>
              <span class="txt-status " v-else-if="row.stat == 62">网点确认完工</span>
              <span class="txt-status neutral" v-else-if="row.stat == 63">中心完工审核</span>
              <span class="txt-status neutral" v-else-if="row.stat == 64">总部完工审核</span>
              <span class="txt-status neutral" v-else-if="row.stat == 91">待结算</span>
              <span class="txt-status disable" v-else-if="row.stat == 92">结算驳回</span>
              <span class="txt-status disable" v-else-if="row.stat == 93">结算中止</span>
              <span class="txt-status " v-else-if="row.stat == 94">已结算</span>
              <span class="txt-status disable" v-else-if="row.stat == 97">申请关闭</span>
              <span class="txt-status disable" v-else-if="row.stat == 98">挂起</span>
              <span class="txt-status disable" v-else-if="row.stat == 99">取消</span>
              <span class="txt-status disable" v-else-if="row.stat == 100">结束</span>
            </template>
          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>
    <!-- <preconditionDialog v-if="showPreconditionDialog" :visiable.sync="showPreconditionDialog" multi="true"/> -->

    <!-- <preconditionDialog2 v-if="showPreconditionDialog2" :visiable.sync="showPreconditionDialog2" multi="true"/> -->

    <!--excel 模板导入 -->
    <excel-upload
      ref="excelUpload"
      title="回访结果导入模板"
      url="/basic/soRecallHistory/import"
      temp-url="/admin/sys-file/local/file/soRecallHistory.xlsx"
      @refreshDataList="refreshChange"
    ></excel-upload>
    <excel-upload
      ref="callExcelUpload"
      title="外呼结果导入模板"
      url="/basic/soRecallHistory/callResultImport"
      temp-url="/admin/sys-file/local/file/soCallResult.xlsx"
      @refreshDataList="refreshChange"
    ></excel-upload>
  </div>
</template>

<script>
import {initVxeTable} from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import {mapGetters} from "vuex";
import api from "@/api/projectApi";
import store from "@/store";
import editView from './edit.vue';
import {doCheckExcle, doDownLoadExcle} from "@/api/intfDownloadRecord/downloadRecord";
import fileNames from "@/api/intfDownloadRecord/fileNames";
import {indexPageMixins} from "@/mixins/tabChang";
import ExcelUpload from "@/components/upload/excel";
// 假数据
// import { initVxeTable } from '@/const/crud/admin/fakeDataTable'
export default {
  name: 'robot',
  mixins: [indexPageMixins],
  inject: ['reload'],
  components: { pager,editView,ExcelUpload},
  data() {
    return {
      isFisrtInit:1,
      props: { multiple: true },
      editViewDataUpdateFlag: false,
      goodsStatusList: [
        {name: "完工待回访", num: 0},
        {name: "待评价", num: 0},
        {name: "二次回访", num: 0},
        {name: "已导入", num: 0},
        {name: "已回访", num: 0},
      ],
      goodsStatusItem: "",//获取点击的元素名称
      goodsStatusIndex: 0,//:class做判断用，默认选中第一个
      total: 0,
      searchValue: null,
      brandOptions: [],
      orderTypeOptions: [],
      serviceTypeOption: [],
      buyChannelOption: [],
      bigCategoryOption: [],
      dispatchStatOptions: [],
      areaProps: {
        lazy: true,
        emitPath: false,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },
      //权限管理
      submitRobot: false,
      soRecallHistoryExport: false,
      soRecallHistoryImport: false,
      requestParam: {
        partsRecall: null,
        deleteOrder: '',
        serviceTypeId: null,
        buyChannelId: null,
        guaranteeType: null,
        siteId: null,
        createTimeBegin: null,
        createTimeEnd: null,
        orderNo: null,
        partsBegin: null,
        partsEnd: null,
        recallBegin: null,
        recallEnd: null,
        queryNum: null,
        isSamePhone: null,
        bigCategoryId: null,
        recallStat:null,
        huiFangQingKuang: null,
        manYi: null,
        completeTimeBegin: null,
        completeTimeEnd: null,
        recallDateBegin: null,
        recallDateEnd: null,
        importRobotTimeBegin: null,
        importRobotTimeEnd: null,
        searchValueIsEnable: false,
        tabStat: '完工待回访',
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量
        orderNoArr: '',//批量工单查询
        serviceTypeIds:[],
        isOutPhone:[],
        rightName: '',
        isFirst:0
      },
      //////////////////////////////////////////////////////////////
      formData: {
        serviceTypeNames: [],
        partsRecall: null,//配件回访结果
        completeDate: null,
        importRobotTime: null,
        createDate: null,
        serviceTypeId: null,
        serviceTypeIds:[],
        buyChannelId: null,
        guaranteeType: null,
        siteId: null,
        createTimeBegin: null,
        createTimeEnd: null,
        orderNo: null,
        partsBegin: 0,
        partsEnd: 1,
        recallBegin: 0,
        recallEnd: 1,
        queryNum: 10000,
        isSamePhone: null,
        bigCategoryId: null,
        recallStat:null,
        huiFangQingKuang: null,
        manYi: null,
        completeTimeBegin: null,
        completeTimeEnd: null,
        recallDateBegin: null,
        recallDateEnd: null,

        importRobotTimeBegin: null,
        importRobotTimeEnd: null,
        deleteOrder: '',//删除工单
        searchValue: null,
        orderNoArr: '',//批量工单查询
        isOutPhone:[],
        rightName:''
      },
      show3: false,
      show4: false,
      input: '',
      canCheck:false,
      showPreconditionDialog: false,
      //  取消执行
      showPreconditionDialog2: false,
      pickerOptions: {

        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      value2: '',
      value3: '',
      value: '',
      activeName: 'second',
      dataId: 0,
      vxeOption: {},
      // 查询参数
      pageSizes: [10, 20, 100],

      showEdit: false,

      columns: [
        {type: 'checkbox', width: 30, title: '', resizable: false, fixed: 'left'},
        {
          width: 80,
          field: 'status',
          fixed: 'right',
          title: '操作',
          showOverflow: true,
          slots: {
            // 使用 JSX 渲染
            default: ({row}) => {
              //单子此时状态  和 能执行的操作     已申诉-此时状态

                return [
                  <div>
                    <a
                      href="javascript:void(0);"
                      class="a-link"
                      onclick={() => {
                        this.openEditDialog(row.id);
                      }}
                    >
                      <el-tooltip enterable={false} effect="dark" content="查看" placement="top"
                                  popper-class="tooltip-skin">
                        <i class="el-icon-edit"/>
                      </el-tooltip>
                    </a>
                  </div>
                ]

            }
          }
        },
        {
          title: '工单号',
          field: 'orderNo',
          width: 180,
          slots: {
            // 使用 JSX 渲染
            default: ({row}) => {
              return [
                <span style="color: blue"
                      onClick={($event) => this.addressClickEvent(row, $event)}>{row.orderNo}</span>
              ]
            }
          }
        },
        {
          title: '用户姓名',
          field: 'userName',
          width: 80,
        },
        {
          title: '用户电话',
          field: 'userMobile',
          width: 120,
        },
        {
          title: '服务类型',
          field: 'serviceTypeName',
          width: 100,
        },
        {
          title: '产品大类',
          field: 'bigCategoryName',
          width: 150,
        },
        {
          title: '保修类型',
          field: 'guaranteeType',
          width: 120,
          slots: {
            default: ({row}) => {
              if (row.guaranteeType == 1) {
                return [
                  <div class="txt-status ">
                    <span>保内</span>
                  </div>
                ];
              } else if (row.guaranteeType == 2) {
                return [
                  <div class="txt-status disable">
                    <span>保外</span>
                  </div>
                ];
              }else if (row.guaranteeType == 3) {
                return [
                  <div class="txt-status disable">
                    <span>未知</span>
                  </div>
                ];
              }
            }
          }
        },
        {
          title: '配件数量',
          field: 'partsQty',
          width: 150,
        },
        {
          title: '完工时间',
          field: 'completeTime',
          width: 150,
        },
        {
          title: '购买渠道',
          field: 'buyChannelName',
          width: 100,
        },
        {
          title: '工单来源',
          field: 'orderTypeName',
          width: 100,
        },
        {
          title: '工单状态',
          field: 'stat',
          width: 125,
          slots: {default: 'showStat'}
        },
        {
          title: '回访状态',
          field: 'recallStat',
          width: 100,
          slots: {
            default: ({row}) => {
              if (row.recallStat == 0) {
                return [
                  <div class="txt-status ">
                    <span>未回访</span>
                  </div>
                ];
              } else if (row.recallStat == 1) {
                return [
                  <div class="txt-status">
                    <span>已导入</span>
                  </div>
                ];
              }else if (row.recallStat == 2) {
                return [
                  <div class="txt-status">
                    <span>已回访</span>
                  </div>
                ];
              }else if (row.recallStat == 5) {
                return [
                  <div class="txt-status">
                    <span>用户已评价</span>
                  </div>
                ];
              }
            }
          }
        },
        {
          title: '导入机器人回访时间',
          field: 'importRobotTime',
          width: 150,
        },
        {
          title: '服务中心',
          field: 'orgName',
          width: 100,
        },
        {
          title: '服务商',
          field: 'siteName',
          width: 80,
        },
        {
          title: '购买日期',
          field: 'buyDate',
          width: 150,
        },
        {
          title: '创建时间',
          field: 'createTime',
          width: 150,
        },
      ],

      columns2: [
        {type: 'checkbox', width: 30, title: '', resizable: false, fixed: 'left'},
        {
          title: '工单号',
          field: 'orderNo',
          width: 180,
          slots: {
            // 使用 JSX 渲染
            default: ({row}) => {
              return [
                <span style="color: blue"
                      onClick={($event) => this.addressClickEvent(row, $event)}>{row.orderNo}</span>
              ]
            }
          }
        },
        {
          title: '用户姓名',
          field: 'userName',
          width: 80,
        },
        {
          title: '用户电话',
          field: 'userMobile',
          width: 120,
        },
        {
          title: '号码重单数',
          field: 'isSamePhone',
          width: 150,
        },
        {
          title: '服务类型',
          field: 'serviceTypeName',
          width: 100,
        },
        {
          title: '产品大类',
          field: 'bigCategoryName',
          width: 150,
        },
        {
          title: '保修类型',
          field: 'guaranteeType',
          width: 120,
          slots: {
            default: ({row}) => {
              if (row.guaranteeType == 1) {
                return [
                  <div class="txt-status ">
                    <span>保内</span>
                  </div>
                ];
              } else if (row.guaranteeType == 2) {
                return [
                  <div class="txt-status disable">
                    <span>保外</span>
                  </div>
                ];
              }else if (row.guaranteeType == 3) {
                return [
                  <div class="txt-status disable">
                    <span>未知</span>
                  </div>
                ];
              }
            }
          }
        },
        {
          title: '配件数量',
          field: 'partsQty',
          width: 150,
        },
        {
          title: '完工时间',
          field: 'completeTime',
          width: 150,
        },
        {
          title: '购买渠道',
          field: 'buyChannelName',
          width: 100,
        },
        {
          title: '工单来源',
          field: 'orderTypeName',
          width: 100,
        },
        {
          title: '工单状态',
          field: 'stat',
          width: 125,
          slots: {default: 'showStat'}
        },
        {
          title: '回访状态',
          field: 'recallStat',
          width: 100,
          slots: {
            default: ({row}) => {
              if (row.recallStat == 0) {
                return [
                  <div class="txt-status ">
                    <span>未回访</span>
                  </div>
                ];
              } else if (row.recallStat == 2) {
                return [
                  <div class="txt-status">
                    <span>已回访</span>
                  </div>
                ];
              }else if (row.recallStat == 5) {
                return [
                  <div class="txt-status">
                    <span>用户已评价</span>
                  </div>
                ];
              }
            }
          }
        },
        {
          title: '服务中心',
          field: 'orgName',
          width: 100,
        },
        {
          title: '服务商',
          field: 'siteName',
          width: 80,
        },
        {
          title: '购买日期',
          field: 'buyDate',
          width: 150,
        },
        {
          title: '回访次数',
          field: 'recallNumber',
          width: 150,
        },
        {
          title: '无果次数',
          field: 'recallNoresutlNumber',
          width: 150,
        },
        {
          title: '回访情况',
          field: 'huiFangQingKuang',
          width: 150,
        },
        {
          title: '满意度',
          field: 'manYi',
          width: 150,
        },
        {
          title: '不满意原因',
          field: 'unSatisfiedReasonName',
          width: 150,
        },
        {
          title: '不满意描述',
          field: 'unSatisfiedRemark',
          width: 150,
        },
        {
          title: '回访人',
          field: 'recallMan',
          width: 150,
        },
        {
          title: '配件回访结果',
          field: 'partsRecallResult',
          width: 150,
        },
        {
          title: '创建日期',
          field: 'createTime',
          width: 150,
        },
        {
          title: '回访时间',
          field: 'recallTime',
          width: 150,
        },
        {
          title: '导入机器人回访时间',
          field: 'importRobotTime',
          width: 150,
        },
      ]
    };
  },
  computed: {
    api() {
      return api
    },
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      };
    },
    ...mapGetters(["permissions"])
  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    activeName(newVal) {
      if (newVal === 'second' && this.editViewDataUpdateFlag) {
        this.getTableData()
      }
    },
    'formData.createDate': {
      handler(newVal, oldVal) {
        if (newVal != null && newVal.length !== 0) {
          this.formData.createTimeBegin = newVal[0]
          this.formData.createTimeEnd = newVal[1]
        } else if (newVal == null) {
          this.formData.createTimeBegin = null
          this.formData.createTimeEnd = null
        }
      },
      deep: true,
    },
    'formData.completeDate': {
      handler(newVal, oldVal) {
        if (newVal != null && newVal.length !== 0) {
          this.formData.completeTimeBegin = newVal[0]
          this.formData.completeTimeEnd = newVal[1]
        } else if (newVal == null) {
          this.formData.completeTimeBegin = null
          this.formData.completeTimeEnd = null
        }
      },
      deep: true,
    },
    'formData.recallDate': {
      handler(newVal, oldVal) {
        if (newVal != null && newVal.length !== 0) {
          this.formData.recallDateBegin = newVal[0]
          this.formData.recallDateEnd = newVal[1]
        } else if (newVal == null) {
          this.formData.recallDateBegin = null
          this.formData.recallDateEnd = null
        }
      },
      deep: true,
    },

    'formData.importRobotTime': {
      handler(newVal, oldVal) {
        if (newVal != null && newVal.length !== 0) {
          this.formData.importRobotTimeBegin = newVal[0]
          this.formData.importRobotTimeEnd = newVal[1]
        } else if (newVal == null) {
          this.formData.importRobotTimeBegin = null
          this.formData.importRobotTimeEnd = null
        }
      },
      deep: true,
    },
  },
  created() {
    this.checkButton = this.permissions["checkButton"];
    this.submitRobot = this.permissions["submitRobot"];//提交机器人
    this.soRecallHistoryExport = this.permissions["soRecallHistoryExport"];//导出
    this.soRecallHistoryImport = this.permissions["soRecallHistoryImport"];//导入
    console.log(this.submitRobot, "this.submitRobot");
  },

  mounted() {
    this.loadBrandOption()
    this.loadOrderTypeOption()
    this.loadServiceTypeOptions()
    this.loadDispatchStatOptions()
    this.loadBuyChannelOptions()
    this.loadbigCategoryOptions();
    //this.loadTabOption()
    this.initSearchDate()

  },

  methods: {

  refreshChange() {
    this.getTableData()
  },

  // 清空所有搜索框
  clearEvent(){
    // this.formData.searchValue='';

    // this.formData=''
    this.formData.partsBegin=''
    this.formData.partsEnd=''
    this.formData.recallBegin=''
    this.formData.recallEnd=''
    this.formData.serviceTypeIds=null
    this.formData.serviceTypeId=null
    this.formData.guaranteeType=null
    this.formData.siteId=null
    this.formData.createTimeBegin=null
    this.formData.createTimeEnd=null
    this.formData.buyChannelId=null
    this.formData.deleteOrder=''
    this.formData.manYi=null
    this.formData.serviceTypeNames=null
    this.formData.siteName=null
    this.formData.bigCategoryId=null
    this.formData.recallStat=null
    this.formData.bigCategoryName=null
    this.formData.importRobotTime=null
    if(this.formData.recallDate){
      this.formData.recallDate=null
      this.formData.recallDateBegin=null
      this.formData.recallDateEnd=null
    }
    if(this.formData.createDate){
      this.formData.createDate=null
      this.formData.createDateBegin=null
      this.formData.createDateEnd=null
    }
    if(this.formData.completeDate){
      this.formData.completeDate =null;
    }
    this.formData.searchValue=null
    this.formData.huiFangQingKuang=null
    this.formData.partsRecall=null
    this.formData.isOutPhone=[]
    this.formData.rightName = ''
  },
    toFilterData() {
          // console.log(55,"触发了搜索");
    // 当用户没有输入内容就按enter键时，就return，不做任何操作，不去搜索
        if(this.formData === '') {
             return
        } else {
        // 请求查询接口，将列表展现出来
            this.searchEvent();
         }
     },
    //选择服务类型
    /*commitServiceTypes(data){
      this.formData.serviceTypeIds =[]
      let checkedCount = data.length;
      for (let i = 0; i < checkedCount; i++) {
        let itemCount = data[i].length
        for(let j = 0; j < itemCount; j++){
          if (!this.formData.serviceTypeIds.includes(data[i][j])){
            this.formData.serviceTypeIds.push(data[i][j])
          }
        }
      }
    },*/
    //选择剔除重复单数
    selectIsOutPhone(value){
      this.formData.isOutPhone = []
      if (value.includes(0)){
        this.canCheck = true
        this.formData.isOutPhone.push(0)
      }else{
        this.canCheck = false
        this.formData.isOutPhone = value
      }
    },
    //提交机器人
    submitRobotAction(){
      if (this.requestParam.tabStat!="完工待回访"){
        this.$message.error('请在完工待回访页进行提交机器人操作！')
        return
      }
      // if (this.formData.isOutPhone.length==0){
      //   this.$message.error('请先选择对应的剔除重单数！')
      //   return
      // }

        this.$baseConfirm('请再次确认当前提交条件，提交时系统将自动进行剔重处理:2单重单将随机导入一单，3单或以上的不导入!').then(() => {
          this.setRequestParam()
          this.$mask.open()
          this.$http({
            url: api.soRecallHistory.submitRobot,
            method: 'post',
            data: this.requestParam
          }).then(res => {
            this.$mask.close()
            this.$message({
              type: res.data.type,
              message: res.data.content
            });
            this.flushed()
          }).catch(() => {
            this.$mask.close()
          });
        })

    },

    //提交挂起取消工单机器人
    submitHCRobotAction(){
      if (this.requestParam.tabStat!="申请挂起"||this.requestParam.tabStat!="申请关闭"){
        this.$message.error('请在申请挂起或者申请关闭页面进行提交外呼机器人操作！')
        return
      }

      this.$baseConfirm('请再次确认当前提交条件，提交时系统将自动进行剔重处理:2单重单将随机导入一单，3单或以上的不导入!').then(() => {
        this.setRequestParam()
        this.$mask.open()
        this.$http({
          url: api.soRecallHistory.submitHCRobot,
          method: 'post',
          data: this.requestParam
        }).then(res => {
          this.$mask.close()
          this.$message({
            type: res.data.type,
            message: res.data.content
          });
          this.flushed()
        }).catch(() => {
          this.$mask.close()
        });
      })

    },


        // 初始化搜索时间
        initSearchDate() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      end = this.$formatDateTime(end, 'yyyy-MM-dd');
start = this.$formatDateTime(start, 'yyyy-MM-dd');
      this.formData.completeDate = [start, end]
      this.requestParam.completeTimeBegin = start
      this.requestParam.completeTimeEnd = end
    },

    //导出
    doExcle(){
      // const  result =
      this.$mask.open()
      doCheckExcle(fileNames.recallScreen).then(response => {
        if (response.data.type=="success"){
          doDownLoadExcle(api.soRecallHistory.doExcelUrl, this.requestParam).then(res => {
            this.$mask.close()
            this.$message({
              type: res.data.type,
              message: res.data.content
            });
          })
          this.$mask.close()
        }else{
          this.$mask.close()
          this.$message({
            type: response.data.type,
            message: response.data.content
          });
        }
      }).catch(() => {
        this.$mask.close()
      })
    },

    editViewDataUpdate() {
      this.editViewDataUpdateFlag = true;
      this.activeName = 'second';
    },

    // 加载tab数据
    async loadTabOption() {
      this.setRequestParam()
      await this.$http({
        url: api.soRecallHistory.getCountUrl,
        method: 'post',
        data: this.requestParam
      }).then(res => {
        console.log("tab数据",res.data.data)
        this.goodsStatusList = res.data.data
        this.goodsStatusList.forEach((item,index) =>{
          if(item.num === null){
            item.num = 0
          }
        })
      })
    },
        // 选中的按钮
    changeGoodsStatus(item, index) {
      console.log(item, index,"点击的item, index");
      this.goodsStatusItem = item.name;//获取点击的元素
      this.goodsStatusIndex = index;//将点击元素的下标和：class中的作对比
      console.log('goodsStatusItem', this.goodsStatusItem)
      this.requestParam.tabStat = this.goodsStatusItem
      // this.$objCopy(this.formData, this.requestParam)
      this.setRequestParam()
      this.requestParam.isFirst = 1
      console.log("号码重单数:"+this.requestParam.isSamePhone);
      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.getTableData()
    },
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
      this.loadTabOption();
      //this.$refs['table-m1'].commitProxy('reload');
    },

    loadDispatchStatOptions() {
      this.$http({
        url: api.basDispatchStat.getList,
        method: 'post',
        data: {
          isShow: 1  //工单查询栏目是否显示:0否1是
        }
      }).then(res => {
        this.dispatchStatOptions = []
        res.data.data.forEach(item =>  {
          this.dispatchStatOptions.push({label:item.dispatchStat})
        })
      })
    },

    // 服务商提示选中
    handleSiteSelect(data) {
      console.log('selectData', data)
      this.formData.siteId = data.id
    },

    // 获取服务商提示
    querySiteSearch(queryStr, callback) {
      this.$http({
        url: api.snUser.getPromptDataUrl,
        method: 'post',
        data: {userName: queryStr}
      }).then(res => {
        console.log(res.data.data, '网点提示内容')
        let temp = []
        res.data.data.forEach(item => {
          temp.push({value: item.userName, id: item.id})
        })
        callback(temp)
      })
    },

    serviceTypeHandleChange(data) {
      console.log('选中的服务类型数据', data)
    },

    loadServiceTypeOptions() {
      this.$http.post(api.basServiceType.getOptionUrl, {}).then(res => {
        // console.log(res.data.data, 'option')
        let list = []
        res.data.data.forEach(item => {
          if (item.children.length == 0) {
            delete item.children
          }
          list.push(item)
        })
        this.serviceTypeOption = list
        console.log(this.serviceTypeOption,"服务类实现");
      })
    },

    //加载购买渠道
    loadBuyChannelOptions() {
      this.$http({
        url: api.basBuyChannel.getListDataUrl,
        method: 'post',
        data: {}
      }).then(res => {
        this.buyChannelOption = res.data.data
        console.log("buyChannelOption",this.buyChannelOption)
      })
    },

    //加载产品大类
    loadbigCategoryOptions() {
      this.$http({
        url: api.basItemCategory.getBigItemCategory,
        method: 'get',
        params: {
          companyId : store.getters.userInfo.tenantId
        }
      }).then(res => {
        this.bigCategoryOption = res.data.data
        console.log("bigCategoryOption",this.bigCategoryOption)
      })
    },

    // 加载工单来源
    loadOrderTypeOption() {
      this.$http({
        url: api.basOrderType.getListUrl,
        method: 'post',
        data: {}
      }).then(res => {
        this.orderTypeOptions = []
        res.data.data.forEach(item => {
          this.orderTypeOptions.push({
            value: item.id,
            label: item.orderTypeName
          })
        })
      })
    },

    // 加载品牌
    loadBrandOption() {
      this.$http({
        url: api.snCompanyBrand.getBrandListUrl,
        method: 'post',
        data: {
          usable: 1  // 加载启用的
        }
      }).then(res => {
        this.brandOptions = [{label: '全部', value: null}]
        res.data.data.forEach(item => {
          this.brandOptions.push({
            label: item.brandName,
            value: item.id
          })
        })
      })
    },

    // 加载table数据
    async getTableData() {
      this.setRequestParam()
      if (this.isFisrtInit == 2 && this.requestParam && this.formData) {
        // 检查完工时间范围是否为空
        if (!this.requestParam.completeTimeBegin && !this.requestParam.completeTimeEnd && !this.formData.completeDate) {
          this.$message.error('请选择完工时间范围');
          return;
        }

        // 检查时间范围是否超过三个月
        if (this.requestParam.completeTimeBegin && this.requestParam.completeTimeEnd) {
          const beginTime = new Date(this.requestParam.completeTimeBegin).getTime();
          const endTime = new Date(this.requestParam.completeTimeEnd).getTime();
          const threeMonthsInMs = 3 * 30 * 24 * 60 * 60 * 1000; // 三个月的毫秒数

          if (endTime - beginTime > threeMonthsInMs) {
            this.$message.error('完工时间范围不能超过三个月');
            return;
          }

          if (endTime < beginTime) {
            this.$message.error('结束时间不能早于开始时间');
            return;
          }
        }
      }
      this.isFisrtInit = 2
      //await this.loadTabOption()
      let tableOption = {
            vue: this,
            tableRef: 'table-m1',
            path: api.soRecallHistory.getTableDataUrl,
            param: this.requestParam,
            method: 'post',
            columns: this.requestParam.tabStat=="完工待回访" || this.requestParam.tabStat=="已导入"? this.columns :this.columns2,
      };
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData();
    },

    // 搜索
    searchEvent() {
      // this.setRequestParam()
      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.requestParam.isFirst = 1
      //this.flushed()
      this.getTableData()
    },
    setRequestParam(){
      this.requestParam.searchValueIsEnable = !this.show3
      this.requestParam.searchValue = this.searchValue
      this.requestParam.orderNo = this.formData.orderNo
      this.requestParam.createTimeBegin = this.formData.createTimeBegin
      this.requestParam.createTimeEnd = this.formData.createTimeEnd
      this.requestParam.serviceTypeId = this.formData.serviceTypeId
      this.requestParam.buyChannelId = this.formData.buyChannelId
      this.requestParam.guaranteeType = this.formData.guaranteeType
      this.requestParam.siteId = this.formData.siteId
      this.requestParam.partsBegin = this.formData.partsBegin
      this.requestParam.partsEnd = this.formData.partsEnd
      this.requestParam.recallBegin = this.formData.recallBegin
      this.requestParam.recallEnd = this.formData.recallEnd
      this.requestParam.queryNum = this.formData.queryNum
      this.requestParam.isSamePhone = this.formData.isSamePhone
      this.requestParam.bigCategoryId = this.formData.bigCategoryId
      this.requestParam.recallStat = this.formData.recallStat
      this.requestParam.huiFangQingKuang = this.formData.huiFangQingKuang
      this.requestParam.manYi = this.formData.manYi
      this.requestParam.completeTimeBegin = this.formData.completeTimeBegin
      this.requestParam.completeTimeEnd = this.formData.completeTimeEnd
      this.requestParam.recallDateBegin = this.formData.recallDateBegin
      this.requestParam.recallDateEnd = this.formData.recallDateEnd

      this.requestParam.importRobotTimeBegin = this.formData.importRobotTimeBegin
      this.requestParam.importRobotTimeEnd = this.formData.importRobotTimeEnd

      this.requestParam.deleteOrder = this.formData.deleteOrder
      this.requestParam.orderNoArr = this.formData.orderNoArr
      this.requestParam.partsRecall = this.formData.partsRecall
      this.requestParam.searchValue = this.formData.searchValue
      this.requestParam.isOutPhone = this.formData.isOutPhone
      this.requestParam.rightName = this.formData.rightName
      this.requestParam.timeTemp = Date.now()
      var typeIds = "";
      if(this.formData.serviceTypeNames != null){
        this.formData.serviceTypeNames.forEach(item => {
          typeIds += item + ","
        })
      }
      if(typeIds != null && typeIds != ""){
        typeIds = typeIds.slice(0,typeIds.length-1);
      }
      console.log("服务类型集合:",typeIds)
      this.requestParam.serviceTypeIds = typeIds;
    },


    // 重置
    resetEvent() {
      this.formData = {
        feeType: '',
        name: ''
      }

      this.requestParam.searchCount = false
      this.requestParam.current = 1
      this.requestParam.name = ''
      this.requestParam.feeType = ''

      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },


    cascaderLazyLoad(node, resolve) {
      if (!node) {
        return false
      }
      this.$http({
        url: api.basArea.getList,
        method: 'post',
        data: {
          parentId: node.value
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        const childrens = response.data.objx || {};
        const nodes = childrens.map(item => ({
          value: item.id,
          label: item.areaName,
          leaf: Number(item.hasChild) > 0
        }))
        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
        resolve(nodes);
      })
    },

    // 地址三级联动
    handleAreaChange() {
      const areaNode = this.$refs["cascaderAddr"].getCheckedNodes();
      this.formData.areaId = areaNode[0].value
      const panelRefs = this.$refs.cascaderAddr.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
    },





    ///////////////////////////////////////////////////////////////////////////////////////////////////


    addressClickEvent(row, id) {
      this.openEditDialog(row.id);
      console.log(row, id, "row");
    },
    // 选中的按钮

    // 考核备注
    open() {
      this.$prompt('请填写考核备注', '备注', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        //   inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        //   inputErrorMessage: '邮箱格式不正确'
      }).then(({value}) => {
        this.$message({
          type: 'success',
          message: '你的添加的考核备注是: ' + value
        });
        this.reload()// 需要刷新页面
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
        this.reload()// 需要刷新页面
      });

    },
    // 打开考核弹窗
    handleCommand(command, b) {
      console.log(command, b, "command,b的值");
      this.$message('click on item ' + b);
      if (b == 1) {
        this.showPreconditionDialog = true;
      } else if (b == 2) {
        this.open()
      }
    },
    // 打开执行考核弹窗
    handleCommand2(command, b) {
      console.log(command, b, "command,b的值");
      this.$message('click on item ' + b);
      if (b == 1) {
        this.showPreconditionDialog2 = true;
      } else if (b == 2) {
        this.open()
      }
    },
    open() {
      this.$prompt('请填写考核备注', '备注', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        //   inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        //   inputErrorMessage: '邮箱格式不正确'
      }).then(({value}) => {
        this.$message({
          type: 'success',
          message: '你的添加的考核备注是: ' + value
        });
        this.reload()// 需要刷新页面
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
        this.reload()// 需要刷新页面
      });

    },
    optionChange(value, target) {
      console.log(111, "11111111");
      console.log(value);
      // var select = document.querySelectorAll(".status_select");
      console.log('接受的option的值1', target)
      // var grade = select.options[select.selectedIndex].value;
      // alert(grade);
      // console.log(grade, "grade的值");
      if (target == 2) {

        this.open()


      }


    },

    gradeChange() {
      console.log(11, "11111111111");
      var objS = document.getElementById("pid");
      var grade = objS.options[objS.selectedIndex].grade;
      alert(grade);
      console.log(grade);
    },

    openEditDialog(id) {
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
      console.log('触发了跳转');
    },


  }
};
</script>
<style lang="scss" scoped>
.el-radio {
    width: 6.5vw!important;
    margin-right: 0!important;
  }
::v-deep .vxe-grid .screen-btns {
  // margin-bottom: 6px;
  border-bottom: 1px solid #ededed !important;
}

.vxe-grid .a-link {
  color: #00c4b3;
  margin-right: 0px !important;
}




// 选中的按钮

.goodsStatus {
  //按钮水平
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-content: space-between;
}

.btnGoodsStatusBt {
  //白底按钮
  // width: 100px;
  margin-right: 20px;
  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  text-align: center;
  background: #fff;
  padding: 5px;
}

.btnGoodsStatusBt1 {
  //红底按钮
  // width: 100px;
  margin-right: 20px;

  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  color: #409eff;
  text-align: center;
  border-bottom: 3px solid #409eff;
  padding: 5px;
}

.num_color {
  display: inline-block;
  margin-left: 5px;
  /* width: 15px; */
  font-size: 12px;
  padding: 4px;
  line-height: 7px;
  height: 12px;
  color: #409eff;
  border-radius: 4px 4px;
  background-color: #ddeaff;
}

// 隐藏搜索框 标题的宽度
.vxe-grid .vxe-form--item .vxe-form--item-title .vxe-form--item-title-label {
  font-size: 12px;
  display: inline-block;
  width: 65px !important;
}


#avue-view {
  overflow: unset !important;
}

.avue-view {
  overflow: unset !important;

}

// ::v-deep .vxe-grid .vxe-pager {
//     font-size: 12px;
//     height: 25px !important;
// 	// overflow: hidden;
// }
::v-deep .el-collapse-item__wrap {
  will-change: height;
  background-color: #FFF;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: none !important;
}

::v-deep .el-collapse-item__header {
  height: 0px;
  line-height: 0px;
  border: none !important;
}

::v-deep .el-collapse-item__header.is-active {
  border-bottom: none;
}

::v-deep .el-collapse {
  border-top: 1px solid #002c93;
  border-bottom: 1px solid #EBEEF5;
  border: none;
}

::v-deep .el-collapse-item__arrow {
  position: relative;
  top: -140px;
  font-size: 18px;
  color: #0077ff;
}

::v-deep .vxe-grid .vxe-form--item-title .vxe-form--item-title-content {
  -webkit-box-flex: 1;
  display: inline-block;
  width: 55px;
  -ms-flex-positive: 1;
  flex-grow: 1;
}

// 隐藏搜索栏
.screen-box {
  display: flex;
}

::v-deep .vxe-grid .vxe-form.screen-box {
  padding: 4px 10px 2px 0;
}

::v-deep .vxe-grid .el-input .el-input__inner {
  height: 28px !important;
}

::v-deep .vxe-grid .vxe-form--item .vxe-form--item-title {
  width: 5vw !important;
  margin-left: 1vw;
}

::v-deep .vxe-grid .vxe-form.screen-box .vxe-form--item .vxe-form--item-inner {
  line-height: 13px;
  height: auto;
  overflow: hidden;
}

::v-deep .vxe-grid .vxe-form .vxe-form--item-inner {
  min-height: 28px;
}
// 选中的按钮

.goodsStatus {
  //按钮水平
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-content: space-between;
}

.btnGoodsStatusBt {
  //白底按钮
  // width: 100px;
  margin-right: 20px;
  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  text-align: center;
  background: #fff;
  padding: 5px;
}

.btnGoodsStatusBt1 {
  //红底按钮
  // width: 100px;
  margin-right: 20px;

  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  color: #409eff;
  text-align: center;
  border-bottom: 3px solid #409eff;
  padding: 5px;
}
::v-deep .item_39 {
  visibility: hidden !important;;
}

::v-deep .item_40 {
  visibility: hidden !important;;
}
</style>
